import {
    IBatchBets,
    IGenericBet,
    ISingleBet,
} from '@bg-shared/business/Reports/interfaces_legacy/Bets';
import { BetStatus } from '@bg-shared/enums/BetStatus';
import { iframeIntegration } from '@bg-shared/integrations';
import { getBatchDelay } from '@bg-shared/business/RecentBets/utils/getDelay';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { webSocketsRepository } from '@bg-shared/infrastructure/WebSockets';
import { RECENT_BETS } from '@bg-shared/constants/socketChannels';
import { recentBetsStore } from './RecentBets.store';

class RecentBetsEvents {
    public configure(): void {
        webSocketsRepository.on<IGenericBet | IBatchBets>(RECENT_BETS, (data) => {
            const isBatch = !!(data as IBatchBets).bets;
            const batchBetsData = data as IBatchBets;
            let batchBets: IBatchBets['bets'] = [];
            let gamesIds = [];

            if (isBatch) {
                batchBets = batchBetsData.bets.filter((bet) =>
                    partnerSettingsStore.availableGamesIds.includes(bet.gameId),
                );

                gamesIds = batchBets.reduce((acc, bet) => {
                    if (!acc.includes(bet.gameId)) {
                        acc.push(bet.gameId);
                    }
                    return acc;
                }, []);
            } else {
                const { gameId } = data as ISingleBet;

                if (gameId && partnerSettingsStore.availableGamesIds.includes(gameId)) {
                    gamesIds = [gameId];
                }
            }

            if (!gamesIds.length) {
                return;
            }

            const bets = isBatch ? batchBets : [data as IGenericBet];

            const delay = getBatchDelay(
                recentBetsStore.value,
                bets,
                partnerSettingsStore.gamesDelays,
            );

            if (bets.some((bet) => bet.status === BetStatus.WON)) {
                iframeIntegration.balanceCheck();
            }

            if (bets.some((bet) => [BetStatus.LOST, BetStatus.RETURNED].includes(bet.status))) {
                iframeIntegration.realityCheck();
            }

            setTimeout(
                () => {
                    recentBetsStore.saveBatchBets(bets);
                },
                Math.max(delay, 0),
            );
        });
    }
}

export const recentBetsEvents = new RecentBetsEvents();
